import React from "react"
import DeleteFilter from "../../../../assets/iconos/close.svg";
import { production_chart } from "../widgets/Charts";
import { windowsActive } from "../../../../config/Helpers";
import ReactEcharts from "echarts-for-react";
import ByDate from "./Production/ByDate";
import Segment from "./Production/Segment";
import Channel from "./Production/Channel";
import Budget from "./Production/Budget";
import CurrentYear from "./Production/CurrentYear";
import LastYear from "./Production/LastYear";
import Reach from "./Production/Reach";

class Production extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            months          : "",
            general_result  : "",
            month_result    : "",
            month_keys      : {},
            totals          : {
                adr_bb_by_widget: 0,
                adr_books_by_widget: 0,
                adr_budget_by_widget: 0,
                adr_ly_by_widget: 0,
                reservations_by_widget: 0,
                reservations_ly_by_widget: 0,
                revenue_bb_by_widget: 0,
                revenue_budget_by_widget: 0,
                revenue_by_widget: 0,
                revenue_by_widget_ly: 0,
                room_nights_bb_by_widget: 0,
                room_nights_books_by_widget: 0,
                room_nights_budget_by_widget: 0,
                room_nights_by_widget_ly: 0
            },
            data_degree_occupancy_time : {
                month_names: [],
                type_names : [],
                values : [],
            },
            statics : [],
            chart_pickup : {},
            statics_segments : [],
            statics_channels : [],
            statics_trimester : [],
            statics_aux : [],
            statics_segments_aux : [],
            statics_channels_aux : [],
            total_widgets : [],
            total_widgets_channels : [],
            filters_segment : [],
            filters_channels : [],
            filters_channels_aux : [],
            key_filter_channel : null,
            filter_ms_active : "inactive",
            filter_month_active : "inactive",
            filter_trimester_active : "inactive",
            filter_segment_active : "inactive",
            request_status : "",
            key_trimester : "",
            active_chart_type : { key : "Day", value : "by_day"},
            tab_submodule : 'inactive',
            tab_filters : 'inactive'
        }
        this.setSegments = this.setSegments.bind(this);
        this.getAgencies = this.getAgencies.bind(this);
        this.activeSegment = this.activeSegment.bind(this);
        this.getDefaultValues = this.getDefaultValues.bind(this);
        this.callMainRequest = this.callMainRequest.bind(this);
    }
    
    getDefaultValues(){
        this.setState({
            months          : "",
            general_result  : "",
            month_result    : "",
            month_keys      : {},
            totals          : {
                adr_bb_by_widget: 0,
                adr_books_by_widget: 0,
                adr_budget_by_widget: 0,
                adr_ly_by_widget: 0,
                reservations_by_widget: 0,
                reservations_ly_by_widget: 0,
                revenue_bb_by_widget: 0,
                revenue_budget_by_widget: 0,
                revenue_by_widget: 0,
                revenue_by_widget_ly: 0,
                room_nights_bb_by_widget: 0,
                room_nights_books_by_widget: 0,
                room_nights_budget_by_widget: 0,
                room_nights_by_widget_ly: 0
            },
            data_degree_occupancy_time : {
                month_names: [],
                type_names : [],
                values : [],
            },
            statics : [],
            chart_pickup : {},
            statics_segments : [],
            statics_channels : [],
            statics_trimester : [],
            statics_aux : [],
            statics_segments_aux : [],
            statics_channels_aux : [],
            total_widgets : [],
            total_widgets_channels : [],
            filters_segment : [],
            filters_channels : [],
            filters_channels_aux : [],
            hide_widget_trimester : "hide-widget",
            key_filter_channel : null,
            filter_ms_active : "inactive",
            filter_month_active : "inactive",
            filter_trimester_active : "inactive",
            filter_segment_active : "inactive",
            request_status : "",
            key_trimester : "",
            active_chart_type : { key : "Day", value : "by_day"},
            tab_submodule : 'inactive',
            tab_filters : 'inactive'
        })
    }

    setDefaultValues(){
        let self = this;
        self.setState(self.getDefaultValues(), function(){
            self._widgetByDate.setState(self._widgetByDate.getDefaultValues());
            self._widgetSegment.setState(self._widgetSegment.getDefaultValues());
        });
    }

    setSegments(segments, key_time, filt) {
        let self = this;
        
        const status  =  (Object.keys(filt).length > 0) ? "active" : "inactive";
        if (segments !== null) {
            self.setState({
                filters_segment: segments,
                filter_month_active: status,
                key_time: filt,
                filter_ms_active : "active"
            }, function () {
                self.props.app.mainRequest();
            })
        } else {
            self.setState({
                filters_segment: [],
                filter_month_active: status,
                filter_segment_active: "inactive",
                statics_channels: {},
                segmentActive : {},
                filter_ms_active : "inactive"
            }, function(){
                self._widgetSegment.setState({
                    segmentActive : {}
                }, function(){
                    self.props.app.mainRequest();
                })
            })
        }
    }

    getAgencies(status, segmentActive) {
        let self = this;
        if (status === 'active') {
            self.setState({
                statics_channels: Object.assign({}, self.state.filters_channels),
                filter_segment_active : "active",
                segmentActive : segmentActive
            }, function(){
                setTimeout(() => {
                    this.forceUpdate();
                }, 100);
                
            })
        } else {
            self.setState({
                statics_channels : {},
                filter_segment_active : "inactive",
                segmentActive : {}

            }, function(){
                setTimeout(() => {
                    this.forceUpdate();
                }, 100);
            })
        }
    }

    activeSegment(status) {
        if (status === "inactive") {
            this.setState({
                filters_channels: [],
                statics_channels: []
            });
        }
        this.setState({
            filter_segment_active: status
        })
    }

    callMainRequest(params = {}){
        let self = this;
        self.props.app.setState(function(prev){
            return {
                sidebar_review : {
                    show : "hide",
                    status: "",
                    current_period : prev.sidebar_review.current_period,
                }
            }
        }, function(){
            self.props.app.mainRequest(params, false)
        })
    }

    getOptionTypeBar = (chart) => {
        let char_keys = Object.keys(this.props.response_request);

        let xAxis = [], 
        current_year_values = [], 
        last_year_value = [], 
        budget = [],
        reach = [];

        let $self = this;
        let result
        if (char_keys.length > 0){
            if(chart === "data_reserves_production"){
                result    = this.props.response_request["table_production"].result;
                xAxis     = Object.keys(result) 
                Object.keys(result).map(function(key, index){
                    reach[index] = result[key]["reach"];
                    budget[index] = result[key]["budget"];
                    current_year_values[index] = result[key]["current_year_value"];
                    last_year_value[index] = result[key]["last_year_value"];
                })
            }
        }
        return production_chart(xAxis, budget, reach, current_year_values, last_year_value, [$self.props.current_year, $self.props.past_year], $self.props.view_results);
    }

    componentWillReceiveProps(props){
        let isset = Object.keys(props.response_request).length > 0;
        if (isset){
            let response = props.response_request["table_production"]
            let self = this;
            if(Object.keys(response).length > 0){
                self.setState(function (prevState) {                
                    let results = {}
                    if (self.state.filters_segment.length > 0) {
                        let filters_channels_aux = {};
                        Object.keys(response.result).map(function(key) {
                            let rr = response.result[key];
                            filters_channels_aux[key] = {}
                            Object.keys(rr).map(function(key_two) {
                                filters_channels_aux[key][key_two] = {};
                                if(key_two !== "totals"){
                                    //let rr2 = rr[key_two]["channels"]
                                    //Object.keys(rr2).map(function(key_three){
                                        //filters_channels_aux[key][key_two][key_three] = rr2[key_three]
                                    //});
                                }else{
                                    filters_channels_aux[key][key_two] = rr[key_two]
                                }
                            });
                        })

                        results = {
                            filters_channels: filters_channels_aux,
                            statics_segments_aux: response.result,
                            statics_segments: response.result
                        }
                    } else {
                        results = {
                            statics_channels: [],
                            statics_segments: [],
                            statics_aux: response.result,
                            statics: response.result,
                            total_widgets: response.totals
                        }
                    }
                    return results;
                }, function () {
                    let filt;
                    filt = self._widgetByDate.state.current_key_time;
                    let state_statics = Object.assign({}, self.state.statics);
                
                    Object.keys(state_statics).map(function(key){
                        if(filt[key] !== undefined){
                            state_statics[key].state = "active";
                        }else{
                            state_statics[key].state = "inactive";
                        }
                    })
                    self.setState({
                        statics_aux : state_statics,
                        statics : state_statics,
                    },function(){
                        if(Object.keys(self._widgetSegment.state.segmentActive).length > 0){
                            self.getChannels("active", self._widgetSegment.state.segmentActive)
                        }
                    })
                })
            }
        }
    }

    render() {
        let $self = this;
        return (
            <section>
                <div className={"datagrid-widget production-year"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">PRODUCTION</span>
                                
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                
                            </div>
                            <div className="row">
                                <div className="col-md-12 datagrid-list">
                                    <ReactEcharts
                                        option={windowsActive(this.props, "reservation", "production") === true ? this.getOptionTypeBar("data_reserves_production") : {} }
                                        notMerge={true}
                                        lazyUpdate={true}
                                        theme={"theme_name"}
                                        
                                        onChartReady={this.onChartReadyCallback}
                                    />
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
                <div className="table-split production-reach">
                    <ByDate
                        layout={this}
                        app={this.props.app}
                        ref={(child) => { this._widgetByDate = child; }}
                    />

                    <div className={"container-aux " + this.state.filter_ms_active}>
                        <Segment
                            layout={this}
                            app={this.props.app}
                            ref={(child) => { this._widgetSegment = child; }}
                        />
                        <Channel
                            app={this.props.app}
                            layout={this}
                            ref={(child) => { this._widgetChannel = child; }}
                        />
                    </div>
                    <CurrentYear
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._currentYear = child; }}
                    />  
                    <Budget
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._budget = child; }}
                    />  
                    <Reach
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._reach= child; }}
                    />  
                    <LastYear
                        app={this.props.app}
                        layout={this}
                        ref={(child) => { this._lastYear = child; }}
                    /> 
                </div>
            </section>
        )
    }
}

export default Production



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/reservations/views/Production.js